import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_secure/_main/")({
  beforeLoad: () => {
    throw redirect({ to: "/projects" }); // eslint-disable-line @typescript-eslint/only-throw-error
  },
});
